import React, { useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { whatsappUrl } from "../components/SiteShell";
import { IMAGES } from "../assets";

export function HomePage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Executive Jiu-Jitsu | Metodologia";
    const hash = window.location.hash.replace(/^#/, "");
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <main>
      {/* 01. HERO */}
      <section className="home-hero">
        <div className="hero-content">
          <p className="eyebrow">{t("home.hero.eyebrow")}</p>
          <h1>
            {t("home.hero.title").split(",")[0]},
            <br />
            <em>{t("home.hero.title").split(",")[1] || t("home.hero.title")}</em>
          </h1>
          <p className="hero-description">{t("home.hero.subtitle")}</p>
          <div className="hero-actions">
            <a className="button" href="#escolha">
              {t("home.hero.chooseMethod")}
            </a>
            <a className="text-link" href="#participar">
              {t("home.hero.howToParticipate")}
            </a>
          </div>
        </div>
        <div className="hero-photo">
          <img src={IMAGES.professorVagner} alt="Professor Vagner Lima" />
          <div className="photo-label">
            <strong>VAGNER LIMA</strong>
            <span>{t("home.hero.photoLabel")}</span>
          </div>
        </div>
      </section>

      {/* 02. DUAS JORNADAS */}
      <section className="journey-section" id="escolha">
        <div className="section-intro">
          <p className="eyebrow">{t("home.journeys.eyebrow")}</p>
          <h2>
            {t("home.journeys.title").split(".")[0]}.
            <br />
            <em>{t("home.journeys.title").split(".")[1] || ""}</em>
          </h2>
          <p>{t("home.journeys.subtitle")}</p>
        </div>
        <div className="journey-grid">
          <Link to="/adult" className="journey-card adult-card">
            <span className="journey-index">01</span>
            <p>{t("home.journeys.adult.tag")}</p>
            <h3>
              Executive
              <br />
              Jiu-Jitsu
            </h3>
            <small>{t("home.journeys.adult.desc")}</small>
            <strong>{t("home.journeys.adult.cta")}</strong>
          </Link>
          <Link to="/kids" className="journey-card kids-card">
            <span className="journey-index">02</span>
            <p>{t("home.journeys.kids.tag")}</p>
            <h3>
              Executive
              <br />
              Jiu-Jitsu <em>Kids</em>
            </h3>
            <small>{t("home.journeys.kids.desc")}</small>
            <strong>{t("home.journeys.kids.cta")}</strong>
          </Link>
        </div>
      </section>

      {/* 03. PONTE TATAME + CORPORATIVO */}
      <section className="bridge-section">
        <div className="bridge-title">
          <p className="eyebrow">{t("home.bridge.eyebrow")}</p>
          <h2>
            {t("home.bridge.title").split("não")[0]}
            <br />
            <em>{t("home.bridge.title")}</em>
          </h2>
        </div>
        <div className="bridge-copy">
          <p>{t("home.bridge.p1")}</p>
          <p>{t("home.bridge.p2")}</p>
          <div className="bridge-flow">
            <span>{t("home.bridge.step1")}</span>
            <i>→</i>
            <span>{t("home.bridge.step2")}</span>
            <i>→</i>
            <span>{t("home.bridge.step3")}</span>
          </div>
        </div>
      </section>

      {/* 04. COMO PARTICIPAR */}
      <section className="participation-section" id="participar">
        <div className="section-intro">
          <p className="eyebrow">{t("home.participation.eyebrow")}</p>
          <h2>
            {t("home.participation.title").split(".")[0]}.
            <br />
            <em>{t("home.participation.title").split(".")[1] || ""}</em>
          </h2>
          <p>{t("home.participation.subtitle")}</p>
        </div>
        <div className="participation-grid">
          <article>
            <span>{t("home.participation.card1.tag")}</span>
            <h3>{t("home.participation.card1.title")}</h3>
            <p>{t("home.participation.card1.desc")}</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              {t("home.participation.card1.cta")}
            </a>
          </article>
          <article>
            <span>{t("home.participation.card2.tag")}</span>
            <h3>{t("home.participation.card2.title")}</h3>
            <p>{t("home.participation.card2.desc")}</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              {t("home.participation.card2.cta")}
            </a>
          </article>
          <article>
            <span>{t("home.participation.card3.tag")}</span>
            <h3>{t("home.participation.card3.title")}</h3>
            <p>{t("home.participation.card3.desc")}</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              {t("home.participation.card3.cta")}
            </a>
          </article>
          <article>
            <span>{t("home.participation.card4.tag")}</span>
            <h3>{t("home.participation.card4.title")}</h3>
            <p>{t("home.participation.card4.desc")}</p>
            <Link to="/kids">{t("home.participation.card4.cta")}</Link>
          </article>
        </div>
        <div className="schedule-strip">
          <div>
            <strong>{t("home.participation.schedule.adultTitle")}</strong>
            <span>{t("home.participation.schedule.adultTime")}</span>
          </div>
          <div>
            <strong>{t("home.participation.schedule.kidsTitle")}</strong>
            <span>{t("home.participation.schedule.kidsTime")}</span>
          </div>
          <div>
            <strong>{t("home.participation.schedule.locationTitle")}</strong>
            <span>{t("home.participation.schedule.locationAddress")}</span>
          </div>
        </div>
      </section>

      {/* 05. ALÉM DO TREINO */}
      <section className="app-section">
        <div className="app-copy">
          <p className="eyebrow">{t("home.beyond.eyebrow")}</p>
          <h2>
            {t("home.beyond.title").split("fora")[0]}
            <br />
            <em>{t("home.beyond.title")}</em>
          </h2>
          <p>{t("home.beyond.subtitle")}</p>
          <div className="app-features">
            <article>
              <span>01</span>
              <div>
                <h3>{t("home.beyond.feature1Title")}</h3>
                <p>{t("home.beyond.feature1Desc")}</p>
              </div>
            </article>
            <article>
              <span>02</span>
              <div>
                <h3>{t("home.beyond.feature2Title")}</h3>
                <p>{t("home.beyond.feature2Desc")}</p>
              </div>
            </article>
            <article>
              <span>03</span>
              <div>
                <h3>{t("home.beyond.feature3Title")}</h3>
                <p>{t("home.beyond.feature3Desc")}</p>
              </div>
            </article>
          </div>
          <Link to="/radar" className="text-link light-link">
            {t("home.beyond.cta")}
          </Link>
        </div>
      </section>

      {/* 06. RADAR PREVIEW */}
      <section className="radar-preview">
        <div className="section-intro">
          <p className="eyebrow">{t("home.radarPreview.eyebrow")}</p>
          <h2>
            {t("home.radarPreview.title").split(".")[0]}.
            <br />
            <em>{t("home.radarPreview.title").split(".")[1] || ""}</em>
          </h2>
          <p>{t("home.radarPreview.subtitle")}</p>
        </div>
        <div className="radar-cards">
          <article>
            <span>{t("home.radarPreview.card1Tag")}</span>
            <h3>{t("home.radarPreview.card1Title")}</h3>
            <p>{t("home.radarPreview.card1Desc")}</p>
          </article>
          <article>
            <span>{t("home.radarPreview.card2Tag")}</span>
            <h3>{t("home.radarPreview.card2Title")}</h3>
            <p>{t("home.radarPreview.card2Desc")}</p>
          </article>
          <article>
            <span>{t("home.radarPreview.card3Tag")}</span>
            <h3>{t("home.radarPreview.card3Title")}</h3>
            <p>{t("home.radarPreview.card3Desc")}</p>
          </article>
        </div>
        <Link to="/radar" className="text-link dark-link">
          {t("home.radarPreview.cta")}
        </Link>
      </section>

      {/* 07. PARCERIAS ESTRATÉGICAS */}
      <section className="partners-home">
        <div>
          <p className="eyebrow">{t("home.partnersPreview.eyebrow")}</p>
          <h2>
            {t("home.partnersPreview.title").split(".")[0]}.
            <br />
            <em>{t("home.partnersPreview.title").split(".")[1] || ""}</em>
          </h2>
          <p>{t("home.partnersPreview.subtitle")}</p>
          <Link to="/partners" className="button">
            {t("home.partnersPreview.cta")}
          </Link>
        </div>
        <Link to="/partners" className="partner-home-card">
          <span>{t("home.partnersPreview.cardTag")}</span>
          <strong>
            DM<span>CON</span>
          </strong>
          <p>{t("home.partnersPreview.cardDesc")}</p>
          <b>{t("home.partnersPreview.cardCta")}</b>
        </Link>
      </section>

      {/* 08. PROFESSOR VAGNER LIMA */}
      <section className="about-professor" id="professor">
        <div className="about-logo">
          <img src={IMAGES.logo} alt="Marca oficial Executive Jiu-Jitsu" />
        </div>
        <div className="about-copy">
          <p className="eyebrow">{t("home.professor.eyebrow")}</p>
          <h2>{t("home.professor.name")}</h2>
          <h3>{t("home.professor.subtitle")}</h3>
          <p>{t("home.professor.desc")}</p>
          <div className="authority-strip">
            <span>
              <strong>{t("home.professor.badge1Num")}</strong> {t("home.professor.badge1Text")}
            </span>
            <span>
              <strong>{t("home.professor.badge2Num")}</strong> {t("home.professor.badge2Text")}
            </span>
          </div>
          <blockquote>{t("home.professor.quote")}</blockquote>
          <a className="button" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
            {t("home.professor.cta")}
          </a>
        </div>
      </section>
    </main>
  );
}
